import type {AuthenticatedUserAuthMethod} from "@vesta/vos-types/modules/platformLevel/authentication/domain/AuthenticatedUserAuthMethod";
import {AuthenticationMethodType} from "@vesta/vos-types/modules/platformLevel/authentication/domain/AuthenticationMethodType";
import type {PrivateInviteByInviteCode} from "@vesta/vos-types/modules/workspaceLevel/privateInvites/domain/PrivateInvite";

export function isPrivateInviteAllowedForAuthMethods({
    invite,
    authMethods,
}: {
    invite: PrivateInviteByInviteCode;
    authMethods: Array<AuthenticatedUserAuthMethod>;
}): boolean {
    return authMethods.some((authMethod) => {
        switch (authMethod.type) {
            case AuthenticationMethodType.otpViaEmail:
            case AuthenticationMethodType.passwordViaEmail:
            case AuthenticationMethodType.ssoViaGoogle:
                return invite.allowedEmail === authMethod.email;
            case AuthenticationMethodType.otpViaSms:
                return invite.allowedPhoneNumber === authMethod.phoneNumber;
            case AuthenticationMethodType.impersonate:
            case AuthenticationMethodType.ssoViaMicrosoft:
                return false;
        }
    });
}
